module.exports = __webpack_public_path__ + "static/media/David_N@3x.0efaa9ba.jpg";